// extracted by mini-css-extract-plugin
module.exports = {"module":"PayrollLoanList_module__2J6DW"};